import { useContextState } from "../../../../../../../hooks/theme"



export const useStyles = () => {
    const { colors: color } = useContextState()

    return {
        input: {
            width: "100%",
            padding: "10px",
            fontSize: "16px",
        },
        mapContainer: {
            //paddingBottom: '30px', 
            padding: '24px',
            marginBottom: '24px',
            border: `1px solid ${color.color13}`,
            borderRadius: '8px',
            '& .MuiFormControlLabel-label': {
                color: color.color13,
            }
        }
    }
}